import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../ui/PageBanner';
import contactUsBannerImage from '../assets/Contact/ContactUsBanner.jpg';
import NotFoundImage from '../assets/no-data.jpg';
import Aos from 'aos';
import 'aos/dist/aos.css';

const NotFound = () => {
  useEffect(() => {
    Aos.init({ duration: 1000, once: false });
  }, []);

  return (
    <div>
      <PageBanner
        title="Not Found"
        breadcrumb="Not Found"
        backgroundImage={contactUsBannerImage}
      />
      
      <div className="flex flex-col items-center justify-center p-10 space-y-6">
        <img
          src={NotFoundImage}
          alt="Page Not Found"
          className="w-full max-w-md"
          data-aos="zoom-in"
        />
        
        <Link
          to="/"
          className="px-6 py-2 bg-blue-600 text-white rounded-full shadow-md hover:bg-blue-700 transition duration-300"
          data-aos="fade-up"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
